import useAvailabilityStore from '../stores/availability.store';
import bg_notification from '../assets/images/bg_notification.png';
import pop_header from '../assets/images/pop_header.png';
import close from '../assets/images/close.png';
import button_login from '../button_login.png';
import { isTelegram } from '../utils/browser';

const PopupNotificationMessage = () => {
  const openModal = useAvailabilityStore((state) => state.openModal);
  const setOpenModal = useAvailabilityStore((state) => state.setOpenModal);
  const message = useAvailabilityStore((state) => state.message);

  if (!openModal) return null;

  return (
    <div
      className="position-fixed top-0 left-0 w-100 h-100 z-3 d-flex justify-content-center align-items-center modal"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)', paddingLeft: 50 }}>
      <div
        className="shadow-md popup-notification"
        style={{
          width: 420,
          height: 380,
          padding: '60px 60px 16px 10px',
          background: `url(${bg_notification})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: '0% 0%',
          backgroundSize: '100% 100%',
          position: 'relative',
        }}>
        <div
          className="popup-notification-header-img"
          style={{
            width: 280,
            height: 80,
            position: 'absolute',
            top: '-45px',
            left: '14%',
          }}>
          <img
            src={pop_header}
            alt=""
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
        <button
          className="btn text-light py-2 popup-notification-btn-close"
          onClick={() => {
            setOpenModal(false);
            if (isTelegram) {
              window.Telegram?.WebApp?.close?.();
            }
          }}
          style={{
            background: `url(${close})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: '0% 0%',
            backgroundSize: '100% 100%',
            position: 'absolute',
            right: '15px',
            top: '-25px',
            width: '60px',
            height: '62px',
            outline: 'none',
            border: 'none',
          }}></button>
        <div style={{ textAlign: 'center' }}>
          <p
            className="press-start-2p-regular popup-notification-description"
            style={{ fontSize: 16, textAlign: 'center', marginBottom: 25, lineHeight: '30px' }}>
            {message}
          </p>
          <button
            style={{
              background: `url(${button_login})`,
              backgroundRepeat: 'no-repeat',
              backgroundPosition: '0% 0%',
              backgroundSize: '100% 100%',
              outline: 'none',
              border: 'none',
              width: 120,
              height: 50,
              fontSize: '18px',
              color: '#90351d',
            }}
            onClick={() => {
              setOpenModal(false);
              if (isTelegram) {
                window.Telegram?.WebApp?.close?.();
              }
            }}>
            <span>OK</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default PopupNotificationMessage;
